module.exports = __webpack_public_path__ + "img/logo.faa8a13c.svg";